<script>
export default {
    name: 'CountDown',
    methods: {
        transformSlotProps(props) {
            const formattedProps = {};

            Object.entries(props).forEach(([key, value]) => {
                formattedProps[key] = value < 10 ? `0${value}` : String(value);
            });

            return formattedProps;
        },
        onCountdownEnd() {

        }

    },
    data() {
        return {

        }
    }
}
</script>
<template >
    <client-only>
        <countdown :time="2 * 15 * 30 * 1000" :emit-events="false" :autoStart="true">
            <template slot-scope="props">
                <div class="bg-red-600 flex items-center justify-center py-2 px-2">
                    <div class="text-white ph-no-capture">
                        <h1 class="text-lg text-center mb-3 font-semibold leading-none text-white">Esta oferta <span
                                class="font-bold">encerra em</span>:</h1>
                        <div class="text-2xl text-center flex w-full items-center justify-center">
                            <div class="w-16 mx-1 p-1 bg-white text-red-700 rounded-lg">
                                <div class="font-mono leading-none" x-text="hours">{{ props.hours }}</div>
                                <div class="font-mono uppercase text-xs leading-none">Horas</div>
                            </div>
                            <div class="w-16 mx-1 p-1 bg-white text-red-700 rounded-lg">
                                <div class="font-mono leading-none" x-text="minutes">{{ props.minutes }}</div>
                                <div class="font-mono uppercase text-xs leading-none">Minutos</div>
                            </div>
                            <div class="w-16 mx-1 p-1 bg-white text-red-700 rounded-lg">
                                <div class="font-mono leading-none" x-text="seconds">{{ props.seconds }}</div>
                                <div class="font-mono uppercase text-xs leading-none">Segundos</div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </countdown>
    </client-only>
</template>
